import { createContext, useContext } from 'react';
import type { PresenceViewer } from './PresenceContract';
import { PresenceIndicator, viewersForItem } from './PresenceIndicator';

export const PresenceContext = createContext<PresenceViewer[]>([]);

export function ItemPresenceIndicator({ type, id }: { type: string; id: string }) {
	const viewers = useContext(PresenceContext);
	return <PresenceIndicator viewers={viewersForItem(viewers, type, id)} />;
}
